var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('center',[_c('h1',[_vm._v("404")]),_c('br'),_c('h2',[_vm._v("Not found")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }